import { render, staticRenderFns } from "./SettingsWages.vue?vue&type=template&id=386e8858&"
import script from "./SettingsWages.vue?vue&type=script&lang=js&"
export * from "./SettingsWages.vue?vue&type=script&lang=js&"
import style0 from "./SettingsWages.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports